<template>
    <v-dialog
      :value="dialogFlag"
      @input="$emit('mychange', $event)"
      @click:outside="closeDialog()"
      max-width="800px"
    >

      <v-card class="rounded-lg">
        <v-toolbar
          class="mb-4 text-center"
            color="#8CC11E"
          dark><span class="text-center">営業日設定(月毎)</span></v-toolbar>


        <v-card-text>

          <v-container class="mt-3">
          <v-row class="d-flex justify-space-between">
              <v-col cols="2" class="text-left"> 年月 </v-col>
              <v-col cols="10" class="text-left">
                  <h3>{{target_year_month}}</h3>
              </v-col>
          </v-row>

    <v-row class="d-flex justify-space-between">
        <v-col cols="2" class="text-left"></v-col>
        <v-col cols="1" class="text-left"></v-col>
        <v-col cols="4" class="text-center">午前</v-col>
        <v-col cols="1" class="text-left"></v-col>
        <v-col cols="4" class="text-center">午後</v-col>
    </v-row>

    <v-row v-for="(v, index) in oya_eigyoubi" :key="v.id" justify="start">
        <v-col cols="2" class="text-left mymidasi" align-self="center">
            {{(v.date+'').slice(5,7)}}月{{(v.date+'').slice(8,10)}}日({{v.dayofweek}})
        </v-col>
        <v-col cols="1" class="text-left" align-self="center">
            <v-checkbox class="mycheck"
                color="#8CC11E"
              v-model="v.first_check"
              @change="change_check(index, 'first_check', v.first_check)"
            ></v-checkbox>
        </v-col>
        <v-col cols="4" class="text-left d-flex flex-nowrap" align-self="start">

                    <v-select dense
                        :items="first_start"
                        v-model="v.first_start"
                        menu-props="auto"
                        outlined
                        placeholder="選択してください"
                        :disabled="!!!v.first_check"
                        :filled="!!!v.first_check"
                        @change="change_shift(index, 'first_end', v.first_start)"
                    ></v-select>

                   <span style="line-height: 2.2em; margin: 0 2px;">～</span>

                    <v-select dense
                        :items="first_end"
                        v-model="v.first_end"
                        menu-props="auto"
                        outlined
                        placeholder="選択してください"
                        :disabled="!!!v.first_check"
                        :filled="!!!v.first_check"
                        @change="change_shift(index, 'first_start', v.first_end)"
                    ></v-select>

        </v-col>
        <v-col cols="1" class="text-left" align-self="start">
            <v-checkbox class="mycheck d-flex align-start"
                color="#8CC11E"
              v-model="v.second_check"
              @change="change_check(index, 'second_check', v.second_check)"
            ></v-checkbox>
        </v-col>
        <v-col cols="4" class="text-left d-flex flex-nowrap" align-self="start">


                    <v-select dense
                        :items="second_start"
                        v-model="v.second_start"
                        menu-props="auto"
                        outlined
                        placeholder="選択してください"
                        :disabled="!!!v.second_check"
                        :filled="!!!v.second_check"
                        @change="change_shift(index, 'second_end', v.second_start)"
                    ></v-select>

                <span style="line-height: 2.2em; margin: 0 2px;">～</span>


                    <v-select dense
                        :items="second_end"
                        v-model="v.second_end"
                        menu-props="auto"
                        outlined
                        placeholder="選択してください"
                        :disabled="!!!v.second_check"
                        :filled="!!!v.second_check"
                        @change="change_shift(index, 'second_start', v.second_end)"
                    ></v-select>


        </v-col>
    </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pb-6">
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            @click.stop.prevent="closeDialog()">キャンセル</v-btn>
          <v-btn dark
            color="#8CC11E"
            @click.stop.prevent="touroku()">登録</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

</template>


<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
/* eslint-disable */



export default {
    props: {
      dialogFlag: Boolean,
      data: Object,
      oya_eigyoubi: Array,
      selected_date: String,
    },
    data() {return {
        // datas
        first_start: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
        first_end: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
        second_start: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
        second_end: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
    }},
    created(){
        console.log('%ccreated: DialogEigyoubi.vue', mycolor.purple);
        console.log(this.oya_eigyoubi);
    },
    computed: {
        target_year_month(){
            console.log(this.selected_date);
            return this.selected_date.replace(/(\d+)-(\d+)-\d+/, '$1年$2月');
        }
    },
    methods: {
        change_check(i, column, v){
            console.log('change_check()');
            console.log('index: ', i);
            console.log('column: ', column);
            console.log('v: ', v);

            if(v==false){
                if(column==='first_check'){
                    this.oya_eigyoubi[i]['first_start'] = '';
                    this.oya_eigyoubi[i]['first_end'] = '';
                }else{
                    this.oya_eigyoubi[i]['second_start'] = '';
                    this.oya_eigyoubi[i]['second_end'] = '';
                }
            }else{
                if(column==='first_check'){
                    this.oya_eigyoubi[i]['first_start'] = '09:00';
                    this.oya_eigyoubi[i]['first_end'] = '13:00';
                }else{
                    this.oya_eigyoubi[i]['second_start'] = '15:00';
                    this.oya_eigyoubi[i]['second_end'] = '19:00';
                }
            }
        },
        change_shift(i, column, v){
          console.log('change_shift()');
          console.log('index: ', i);
          console.log('column: ', column);
          console.log('v: ', v);

          // 時刻の片方が空だったらペアも空にする.
          if(v===''){
              this.oya_eigyoubi[i][column] = '';
          }
        },

        closeDialog(){

            console.log('closeDialog()');
            this.$emit('closeDialog', 'gohenshin');
        },
        touroku(){
            console.log('touroku()');
              // 登録前のバリデーション

              console.log('oya_eigyoubi: ', this.oya_eigyoubi);

              var api = '/validate_time_with_date';
              axios.post(api, this.oya_eigyoubi)
                .then((res) => {
                  console.group();
                  console.log(`%c${api}`, mycolor.purple);
                  console.log(res.data);
                  console.groupEnd();

                  if(res.data===true){
                    console.log('バリデーション OK');
                    this.$emit('tourokuEigyoubi', 'gohenshin');
                  }else{
                    alert(res.data);
                  }

                })
                .catch(() => {
                  // eslint-disable-next-line
                  console.error();
                });
                return false;

        },


        add_minutes(dt, minutes) {
            let d = new Date(dt);
            return new Date(d.getTime() + minutes*60000);
        },

        getArrayTimes(is_end){
            let dt = is_end ? `${this.date_selected} ${this.start_selected}` : `${this.date_selected} 09:00` ;
            let loop_times = is_end ? 4*2 : 4*24;
            let myarray = is_end ? [`${this.start_selected}`] : ['09:00'];
            let time_str = '';
            for(let i=0; i<loop_times; i++){
                dt = this.add_minutes(dt, 15);

                time_str = (dt.getHours()+'').padStart(2, '0') + ':' + (dt.getMinutes()+'').padStart(2, '0');
                myarray.push(time_str);
                if( time_str==='19:00'){
                    break;
                }
            }
            return myarray;
        },


    }, // methods
}
</script>

<style scoped>
.my_border{
    border: solid 1px #444;
    border-radius: 6px;
    padding: 8px;
}
.blue_border{
    border: solid 1px blue;
}
.row > div {
    max-height: 60px;
}
.mymidasi{
    height: 60px;
    min-height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.mycheck{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    margin-top: -6px;
}
</style>
